import { render, staticRenderFns } from "./TaxReceiptForm.vue?vue&type=template&id=6bf65040&scoped=true&"
import script from "./TaxReceiptForm.vue?vue&type=script&lang=js&"
export * from "./TaxReceiptForm.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/forms.css?vue&type=style&index=0&id=6bf65040&scoped=true&lang=css&"
import style1 from "./TaxReceiptForm.vue?vue&type=style&index=1&id=6bf65040&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf65040",
  null
  
)

export default component.exports